import React, { useState } from 'react';
import { saveAs } from './FileSaver';

const Api = require('./Config');
const VIEW_ALL = 'View all';

const PatientsCSV = ({ archived, tCodeFilter, refFilter, statusFilter, sortBy, sortDir }) => {
  const [isLoading, setIsLoading] = useState(false);

  const getTcodes = async () => {
    let tcodeItems = [];
    let tcodeCount = 0;
    let startIdx = 0;
    const queryAmount = 300;

    let filters = {
      tcode: tCodeFilter.toLowerCase().replaceAll(' ', ''),
      patientRef: refFilter.toLowerCase(),
    };

    if (statusFilter != VIEW_ALL) {
      filters.status = statusFilter;
    }

    const sort = { sortBy, sortDir };

    do {
      const results = await Api.getJourneysForDoctor(archived, startIdx, queryAmount, filters, sort);
      const currentTcodes = results.tcodes;
      tcodeItems = tcodeItems.concat(currentTcodes);
      tcodeCount = currentTcodes.length;
      startIdx = results.newIndex + tcodeCount;
    } while (tcodeCount > 0);

    return tcodeItems;
  };

  const doCsv = async () => {
    setIsLoading(true);

    const tcodes = await getTcodes();
    console.log(tcodes);
    let csv = 'Run Date,' + Api.getDateFormat(new Date(), false);
    csv += '\r\n';
    csv += '\r\n';

    const headings = ['Patient', 'Group', 'Year of Birth', 'Gender', 'App Id', 'Journey', 'Tcode', 'Created', 'Status'];

    csv += headings.join(',');
    csv += '\r\n';

    for (let counter = 0; counter < tcodes.length; counter += 1) {
      const row = tcodes[counter];
      const rowOutput = [
        row.patient_ref,
        row.group_name,
        row.yob,
        row.gender,
        row.app_id,
        row.journey_name,
        row.t_code,
        Api.getDateFormat(row.journey_start_date, true),
        row.STATUS,
      ];

      csv += rowOutput.join(',');
      csv += `\r\n`;
    }
    const blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, `${new Date()} - patients - report.csv`);
    setIsLoading(false);
  };

  return (
    <button onClick={doCsv} className="btn btn-primary" type="button" disabled={isLoading}>
      <i className="fa fa-download " style={{ marginRight: 5 }} />
      CSV
    </button>
  );
};

export default PatientsCSV;
